{
    "May the force be with you": "May the force be with you",
    "Digit1": "1",
    "Digit2": "2",
    "Digit3": "3",
    "Digit4": "4",
    "Digit5": "5",
    "Digit6": "6",
    "Digit7": "7",
    "Digit8": "8",
    "Digit9": "9",
    "Digit0": "0",
    "KeyA": "A",
    "KeyB": "B",
    "KeyC": "C",
    "KeyD": "D",
    "KeyE": "E",
    "KeyF": "F",
    "KeyG": "G",
    "KeyH": "H",
    "KeyI": "I",
    "KeyJ": "J",
    "KeyK": "K",
    "KeyL": "L",
    "KeyM": "M",
    "KeyN": "N",
    "KeyO": "O",
    "KeyP": "P",
    "KeyQ": "Q",
    "KeyR": "R",
    "KeyS": "S",
    "KeyT": "T",
    "KeyU": "U",
    "KeyV": "V",
    "KeyW": "W",
    "KeyX": "X",
    "KeyY": "Y",
    "KeyZ": "Z",
    "Comma": ",",
    "Period": ".",
    "Semicolon": ";",
    "Quote": "'",
    "BracketLeft": "[",
    "BracketRight": "]",
    "Backquote": "`",
    "Backslash": "\\",
    "Minus": "-",
    "Equal": "=",
    "AltLeft": "Alt",
    "AltRight": "Alt",
    "CapsLock": "CapsLock",
    "ControlLeft": "ControlLeft",
    "ControlRight": "ControlRight",
    "OSLeft": "OSLeft",
    "OSRight": "OSRight",
    "ShiftLeft": "ShiftLeft",
    "ShiftRight": "ShiftRight",
    "ContextMenu": "ContextMenu",
    "Enter": "Enter",
    "Space": "Space",
    "Tab": "Tab",
    "Delete": "Delete",
    "End": "End",
    "Help": "Help",
    "Home": "Home",
    "Insert": "Insert",
    "PageDown": "PageDown",
    "PageUp": "PageUp",
    "ArrowDown": "ArrowDown",
    "ArrowLeft": "ArrowLeft",
    "ArrowRight": "ArrowRight",
    "ArrowUp": "ArrowUp",
    "Escape": "Escape",
    "PrintScreen": "PrintScreen",
    "ScrollLock": "ScrollLock",
    "Pause": "Pausa",
    "Put the videos side by side": "Posizionare i video uno accanto all'altro",
    "Minimize video": "Minimizza il video",
    "Close video": "Chiudi il video",
    "Place the video on the other side of the screen": "Posizionare il video sull'altro lato dello schermo",
    "Maximize video": "Ingrandisci il video",
    "Swap position of the videos": "Scambiare le posizioni dei video",
    "loadManifest(): Invalid current player state: $1": "loadManifest(): Stato di riproduzione attuale non valido: $1 ",
    "loadPlayer(): Invalid current player state: $1": "loadPlayer(): Stato di riproduzione attuale non valido: $1 ",
    "Could not load player: state transition in progress: $1": "Impossibile caricare il Player: transizione di stato in corso: $1",
    "Could not unload player: state transition in progress: $1": "Impossibile eliminare il Player: transizione di stato in corso: $1",
    "unloadManifest(): Invalid current player state: $1": "unloadManifest(): Stato del Player attualmente non valido: $1",
    "Error loading video manifest: $1 $2": "Errore durante il caricamento delle informazioni video: $1 $2",
    "Play/pause": "Riproduci/Pausa",
    "Select the active audio track": "Seleziona traccia audio attiva",
    "Toggle audio mute": "Attiva/disattiva audio",
    "Toggle play/pause": "Attiva/disattiva riproduzione",
    "Toggle captions": "Attiva/disattiva sottotitoli",
    "Backward $1 seconds": "Indietro di $1 secondi",
    "Forward $1 seconds": "Avanti di $1 secondi",
    "Volume up 10%": "Aumenta il volume del 10%",
    "Volume down 10%": "Diminuisci il volume del 10%",
    "Close pop-up": "Chiudi finestra pop-up",
    "Decrease playback speed": "Riduci la velocità di riproduzione",
    "Increase playback speed": "Aumenta la velocità di riproduzione",
    "Swap between side by side and minimized video": "Passaggio dalla visualizzazione affiancata alla visualizzazione ridotta del video",
    "Swap the position of the videos": "Cambio delle posizioni video",
    "Dual stream 50%": "Dual stream 50%",
    "Two videos 50%": "Due video 50%",
    "Play": "Riproduci",
    "Play/Pause button": "Pulsante Riproduci/Pausa",
    "Starts and stops video playback. When the video reaches the end, this button also allows you to restart playback from the beginning.": "Avvia e interrompe la riproduzione del video. Quando il video arriva alla fine, questo pulsante consente anche di riavviare la riproduzione dall'inizio.",
    "Toolbar": "Barra degli strumenti",
    "Left-side buttons": "Pulsanti a sinistra",
    "Right-side buttons": "Pulsanti a destra",
    "Back": "Indietro",
    "playPauseButtonHelp.title": "Aiuto pulsante Riproduci/Pausa",
    "playPauseButtonHelp.description": "Questo pulsante permette di riprodurre o mettere in pausa il video.",
    "Options": "Opzioni",
    "Configuration options": "Opzioni di configurazione",
    "Settings": "Impostazioni",
    "Settings options": "Opzioni di impostazione"
}
